import { render } from "./MediaArea.vue?vue&type=template&id=64d4d681&scoped=true"
import script from "./MediaArea.vue?vue&type=script&lang=js"
export * from "./MediaArea.vue?vue&type=script&lang=js"

import "./MediaArea.vue?vue&type=style&index=0&id=64d4d681&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d4d681"]])

export default __exports__